import { addMethod, StringSchema } from 'yup'

export const emptyStringAsUndefinedTransform = () => {
  addMethod(StringSchema, 'emptyAsUndefined', function emptyAsUndefined() {
    return this.transform((value, originalValue) =>
      String(originalValue)?.trim() ? value : undefined,
    )
  })
}
